import React from 'react';
import { Link } from 'react-router-dom';

const Blog = ( props ) => {

    return (
        <Link to={props.id} style={{textDecoration:'none'}}>
            <section className="main-blog__content">
                <img className="main-blog__image" src={props.blog.image} alt="thumbnail" loading="lazy" />
                <div className="main-blog__info">
                    <div className="main-blog__tag">{props.blog.tags}</div>
                    <div className="main-blog__title">{props.blog.title}</div>
                    <div className="main-blog__excerpt">
                        {props.blog.excerpt.length > 300 ? `${props.blog.excerpt.substring(0, 254)}...` : props.blog.excerpt}
                    </div>
                </div>
            </section>
        </Link>
    );

}

export default Blog;